export const SUPERSIZE_MY_EDIT_VALUES = {
  SIMPLE_GRAPHICS: 'SIMPLE_GRAPHICS',
  ADDITIONAL_AMENDMENTS: 'ADDITIONAL_AMENDMENTS',
  ADDITIONAL_MEDIA: 'ADDITIONAL_MEDIA',
  OTHER: 'OTHER'
};

export const SUPERSIZE_MY_EDIT_LABELS = {
  SIMPLE_GRAPHICS: 'Simple Graphics',
  ADDITIONAL_AMENDMENTS: 'Additional Amendments',
  ADDITIONAL_MEDIA: 'Additional Media',
  OTHER: 'Other'
};

export const addonsWithRelatedInput = [SUPERSIZE_MY_EDIT_VALUES.OTHER];